import { AppSettingContext } from "@src/components/Application";
import IBasketDetailsProps from "@src/models/props/BasketDetailsProps.interface";
import React, { useEffect, useState } from "react";
import { isAnBuyGiftCard } from "../../../helpers/GiftCardHelper";
import { GiftCardSendTypeEnum } from "../../../models/enums/GiftCardSendTypeEnum";

const BasketDetails = (props: IBasketDetailsProps) => {
    //Page translation
    const { labels } = React.useContext(AppSettingContext);
    const [cardValue, setCardValue] = useState(0);

    useEffect(() => {
        //if (isAnBuyGiftCard(props.giftCard)) {
        //    setCardValue(props.giftCard.chooseCard.value);

        //} else if (isAnRegiftCard(props.giftCard)) {
        //    setCardValue(props.giftCard.regiftCardStep.value);
        //}
        if (isAnBuyGiftCard(props.giftCard)) {
            setCardValue(props.giftCard.chooseCard.value);

        } else {
            setCardValue(props.giftCard.regiftCardStep.value);
        }

    });

    const [error, setError] = useState(null);
    if (error) throw error;
    return (
        <>
            <h5>{labels.get("GiftCard.App.Steps.PreviewAndPay.Subsection.Options.Title")}</h5>
            <p className="label-fs sending-to">{labels.get("GiftCard.App.Steps.PreviewAndPay.Subsection.Options.Subtitle")}</p>
            <div className="table-responsive">
                <div className="table-border">
                    <table>
                        <thead>
                            <tr>
                                <th>{labels.get("GiftCard.App.Steps.PreviewAndPay.Subsection.Options.Recipient")}</th>
                                <th>{labels.get("GiftCard.App.Steps.PreviewAndPay.Subsection.Options.Value")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.giftCard.recipientsStep.recipients.map((recipient, index) => (
                                <tr key={index}>
                                    <td>
                                        <p>{recipient.firstName} {recipient.lastName}</p>

                                        {props.giftCard.recipientsStep.sendBy == GiftCardSendTypeEnum.BY_EMAIL &&
                                            <p>{recipient.email}</p>}
                                        {props.giftCard.recipientsStep.sendBy == GiftCardSendTypeEnum.BY_SMS &&
                                            <p>{recipient.phone}</p>}
                                    </td>
                                    <td>
                                        <p>&euro;{cardValue.toFixed(2)}</p>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            {props.giftCard.paymentStep.paymentDetails.totalFees > 0 &&
                                <tr>
                                    <td>
                                        <h5>{labels.get("GiftCard.App.Steps.PreviewAndPay.Subsection.Options.Fees")}</h5>
                                    </td>
                                    <td>&euro;{props.giftCard.paymentStep.paymentDetails.totalFees.toFixed(2)}</td>
                                </tr>}
                            <tr>
                                <td>
                                    <h5>{labels.get("GiftCard.App.Steps.PreviewAndPay.Subsection.Options.Total")}</h5>
                                </td>
                                <td>&euro;{props.giftCard.paymentStep.paymentDetails.totalAmount.toFixed(2)}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </>
    )
}

export default BasketDetails;